import { FuseAnimate } from '@fuse';
import { AppBar, DialogContent, IconButton, Toolbar, Typography } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { MdClose } from 'react-icons/md';

class FluxoErrorDialog extends XAPPComponent {

    render() {
        const { open, openDialog } = this.props;
        return (
            <XAPPDialog
                id="FluxoError"
                onClose={() => openDialog()}
                open={open !== null}
                fullWidth
                fullScreen
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"ERRO"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog()}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "p-0" }}>
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                        <div className="max-w-512 text-center">
                            <FuseAnimate delay={500}>
                                <Typography variant="h5" color="textSecondary" className="mb-16">
                                    {'Ops, fluxo não encontrado. Por favor entre em contato com o administrador do sistema. Obrigado'}
                                </Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                </DialogContent>
            </XAPPDialog>
        );
    }
}


export default FluxoErrorDialog;
